/* PoCichu — przesuwanie galerii palcem. v2, 04.09.2026

   Problem: galeria na stronie produktu to zakładki. Każdy kadr ma display:none,
   widoczny jest tylko ten z klasą .on, a przełącza się go wyłącznie klikając
   miniaturę pod spodem. Na telefonie to nienaturalne — 80% ruchu to telefon,
   a tam odruch jest jeden: przesunąć zdjęcie palcem.

   Rozwiązanie: poniżej 900 px zamieniam .pc-stage w poziomy pas z zatrzaskiem
   (scroll-snap). Wszystkie kadry stoją obok siebie, palec przewija, miniatury
   podświetlają się same. Na desktopie zostają zakładki — tam kursor klika
   miniaturę i to jest w porządku.

   Trzy kierunki synchronizacji, wszystkie obsłużone:
   1. przesunięcie palcem  -> podświetlenie miniatury
   2. klik w miniaturę     -> przewinięcie pasa
   3. zmiana koloru w karcie zakupu (skrypt sekcji woła goTo, czyli przestawia
      klasę .on) -> przewinięcie pasa. Stąd obserwator klas.

   Uwaga: dławimy przez setTimeout, nie przez requestAnimationFrame. rAF nie
   odpala się w karcie, która nie jest widoczna, więc flaga blokady potrafiłaby
   zostać włączona na zawsze i galeria przestałaby się synchronizować.

   Cofnięcie całości = usunięcie jednej linijki <script> ze snippets/stylesheets.liquid. */
(function () {
  'use strict';

  var TAG = '[pocichu-galeria]';
  var MQ = window.matchMedia('(max-width: 899px)');

  var stage = null;
  var thumbs = null;
  var slides = [];
  var buttons = [];
  var cur = 0;
  var lock = false; /* blokada pętli: my zmieniamy .on -> obserwator ma milczeć */
  var czekaScroll = false;
  var mo = null;

  function log() {
    var a = Array.prototype.slice.call(arguments);
    a.unshift(TAG);
    try { console.log.apply(console, a); } catch (err) {}
  }

  function activeIndex() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('on')) return i;
    }
    return 0;
  }

  function scrollThumbIntoView(btn) {
    if (!thumbs || !btn) return;
    var l = btn.offsetLeft;
    var r = l + btn.offsetWidth;
    var vl = thumbs.scrollLeft;
    var vr = vl + thumbs.clientWidth;
    if (l < vl) thumbs.scrollTo({ left: l - 8, behavior: 'smooth' });
    else if (r > vr) thumbs.scrollTo({ left: r - thumbs.clientWidth + 8, behavior: 'smooth' });
  }

  /* Ustawia kadr numer i. doScroll=true, gdy to my mamy przewinąć pas
     (klik w miniaturę, zmiana koloru). Przy przewijaniu palcem pas jest
     już we właściwym miejscu i przewijanie go drugi raz szarpałoby obrazem. */
  function setActive(i, doScroll) {
    if (i < 0 || i >= slides.length) return;
    cur = i;
    lock = true;

    for (var k = 0; k < slides.length; k++) {
      slides[k].classList.toggle('on', k === i);
    }
    for (var b = 0; b < buttons.length; b++) {
      buttons[b].classList.toggle('on', b === i);
    }
    scrollThumbIntoView(buttons[i]);

    if (doScroll && stage.clientWidth) {
      stage.scrollTo({ left: i * stage.clientWidth, behavior: 'smooth' });
    }

    setTimeout(function () { lock = false; }, 0);
  }

  function onScroll() {
    if (czekaScroll) return;
    czekaScroll = true;
    setTimeout(function () {
      czekaScroll = false;
      if (!stage.classList.contains('pc-swipe')) return;
      var w = stage.clientWidth;
      if (!w) return;
      var i = Math.round(stage.scrollLeft / w);
      if (i === cur) return;
      setActive(i, false);
    }, 60);
  }

  /* Klik w miniaturę. Faza przechwytywania na pasku miniatur wyprzedza
     własne uchwyty przycisków ze skryptu sekcji (te wołają goTo i przestawiają
     display, co w trybie przesuwania nic by nie dało). */
  function onThumbClick(e) {
    if (!MQ.matches) return;
    var b = e.target && e.target.closest ? e.target.closest('button[data-t]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    setActive(parseInt(b.getAttribute('data-t'), 10) || 0, true);
  }

  function enable() {
    if (stage.classList.contains('pc-swipe')) return;
    stage.classList.add('pc-swipe');
    var i = activeIndex();
    cur = i;
    /* bez animacji przy pierwszym ustawieniu — strona ma się wczytać już we
       właściwym kadrze, a nie przejechać w bok na oczach użytkownika */
    stage.scrollLeft = i * stage.clientWidth;
    for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('on', k === i);

    if (!mo) {
      mo = new MutationObserver(function () {
        if (lock) return;
        if (!stage.classList.contains('pc-swipe')) return;
        var t = activeIndex();
        var w = stage.clientWidth;
        if (!w) return;
        if (Math.round(stage.scrollLeft / w) === t) return;
        setActive(t, true);
      });
    }
    mo.observe(stage, { subtree: true, attributes: true, attributeFilter: ['class'] });
    log('przesuwanie palcem włączone, kadrów: ' + slides.length);
  }

  function disable() {
    if (!stage.classList.contains('pc-swipe')) return;
    stage.classList.remove('pc-swipe');
    stage.scrollLeft = 0;
    if (mo) mo.disconnect();
    var i = cur;
    for (var k = 0; k < slides.length; k++) slides[k].classList.toggle('on', k === i);
  }

  function apply() {
    if (MQ.matches) enable();
    else disable();
  }

  function init() {
    stage = document.querySelector('.pc-gal .pc-stage');
    if (!stage) return;
    slides = Array.prototype.slice.call(stage.querySelectorAll('.pc-slide'));
    if (slides.length < 2) return;

    thumbs = document.getElementById('pc-thumbs');
    buttons = thumbs ? Array.prototype.slice.call(thumbs.querySelectorAll('button[data-t]')) : [];

    stage.addEventListener('scroll', onScroll, { passive: true });
    if (thumbs) thumbs.addEventListener('click', onThumbClick, true);

    if (MQ.addEventListener) MQ.addEventListener('change', apply);
    else if (MQ.addListener) MQ.addListener(apply);

    /* Po obrocie telefonu szerokość kadru się zmienia — pas trzeba dosunąć,
       inaczej zatrzask zostawia zdjęcie w połowie. */
    window.addEventListener('resize', function () {
      if (!stage.classList.contains('pc-swipe')) return;
      stage.scrollLeft = cur * stage.clientWidth;
    }, { passive: true });

    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
